<template>
  <div class="body">
    <div class="banner">
      <img :src="banner" />
    </div>

    <div class="contents">
      <p class="contents-title">多场景品牌展示，解锁更多商机</p>
      <div class="contentslist">
        <li class="contents-li" v-for="(mitem, index) in list">
          <img :src="mitem.img" />
          <p class="contents-li-title">
            {{ mitem.title }}
          </p>
          <p class="contents-li-desc">
            {{ mitem.desc }}
          </p>
        </li>
      </div>
    </div>
    <div class="cloud">
      <div class="contents contents-cloud">
        <p class="cloud-title">工业机器人产业链一站式供需对接“云采购”平台</p>
        <ul class="cloud-ul">
          <li>
            <span class="cloud-ul-dian">•</span
            >汇聚中国工业机器人上下游名、特、优生产制造企业及工业机器人企业
          </li>
          <li>
            <span class="cloud-ul-dian">•</span
            >优质服务，快速响应，及时抵达，系统解决
          </li>
          <li><span class="cloud-ul-dian">•</span>行业丰富，汇集多样客户群</li>
        </ul>
      </div>
    </div>

    <div class="contents">
      <p class="contents-title">MOVIBOT能为您带来什么?</p>
      <div class="contentslist">
        <li class="contents-help-li" v-for="(helpitem, index) in helplist">
          <img :src="helpitem.img" />
          <p class="contents-li-title">
            {{ helpitem.title }}
          </p>
        </li>
      </div>
    </div>

    <div class="contents">
      <p class="contents-title contents-title-save">合作意向沟通</p>
      <div class="contentsus contentsus">
        <div class="contentsus-left">
          <p class="contentsus-left-title">合作热线</p>
          <p class="contentsus-left-info">合作热线：186-4910-2821</p>
          <p class="contentsus-left-info">服务邮箱：public@tjchenxing.com</p>
          <p class="contentsus-left-lable">
            热线客服工作时间：周一至周六8:30-17:30
          </p>
        </div>
        <div class="contentsus-right">
          <!-- <img :src="helpimg"> -->
          <p class="contentsus-right-title">留下联系信息，等待MOVIBOT联系</p>
          <el-form ref="form" :model="form" :rules="rules">
            <div class="xing">
              <el-form-item prop="name">
                <el-input v-model="form.name" placeholder="名"></el-input>
              </el-form-item>
              <el-form-item prop="surname">
                <el-input v-model="form.surname" placeholder="姓"></el-input>
              </el-form-item>
            </div>
            <div class="xing">
              <el-form-item prop="mail">
                <el-input v-model="form.mail" placeholder="邮箱"></el-input>
              </el-form-item>
              <el-form-item prop="phone">
                <el-input v-model="form.phone" placeholder="电话"></el-input>
              </el-form-item>
            </div>
            <el-form-item prop="company">
              <el-input
                v-model="form.company"
                placeholder="公司名称"
              ></el-input>
            </el-form-item>
            <el-form-item prop="content">
              <el-input
                type="textarea"
                v-model="form.content"
                placeholder="请描述您的需求，以便我们为您提供服务"
              ></el-input>
            </el-form-item>
            <el-form-item prop="type">
              <el-checkbox-group v-model="form.type">
                <el-checkbox name="type"
                  >当您提交信息后，我们将会以邮件或电话的方式回复您，请您阅读我们的<router-link
                    :to="{ name: 'privacy' }"
                    tag="a"
                    target="_blank"
                    >隐私政策</router-link
                  >,我们将严格按照您同意的<router-link
                    :to="{ name: 'privacy' }"
                    tag="a"
                    target="_blank"
                    >隐私政策</router-link
                  >使用您的个人信息。</el-checkbox
                >
              </el-checkbox-group>
            </el-form-item>
            <el-form-item>
              <el-button round type="primary" @click="onSubmit('form')"
                >提交</el-button
              >
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Message } from "element-ui";
export default {
  data() {
    var validatorPhone = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("手机号不能为空"));
      } else if (!/^1\d{10}$/.test(value)) {
        callback(new Error("手机号格式错误"));
      } else {
        callback();
      }
    };
    return {
      banner: "/static/help/purchasebanner.png",
      helpimg: "/static/help/help.png",
      list: [
        {
          title: "精准触达",
          desc: "精准产品筛选,详细产品展示，以产品触达品牌",
          img: "/static/help/send.png",
          url: "/help/fqa"
        },
        {
          title: "品牌展示",
          desc: "专属品牌页，产品与品牌深度绑定，提升品牌知名度",
          img: "/static/help/brand.png",
          url: "/help/purchase"
        },
        {
          title: "提高商机转化率",
          desc: "产品信息展示明晰，多场景展示产品应用方案，提升购买转化率",
          img: "/static/help/xiaov.png",
          url: "/help/cooperation"
        }
      ],
      helplist: [
        {
          title: "线上销售渠道增加",
          img: "/static/help/purchase1.png"
        },
        {
          title: "海内外客户群扩展",
          img: "/static/help/purchase2.png"
        },
        {
          title: "品牌知名度提升",
          img: "/static/help/purchase3.png"
        }
      ],
      form: {
        name: "",
        surname: "",
        mail: "",
        phone: "",
        company: "",
        type: [],
        content: ""
      },
      rules: {
        name: [{ required: true, message: "请输入名", trigger: "blur" }],
        surname: [{ required: true, message: "请输入姓", trigger: "blur" }],
        phone: [{ required: true, validator: validatorPhone, trigger: "blur" }],
        content: [
          { required: true, message: "请输入问题", trigger: "blur" },
          { min: 2, message: "问题最少10个字符", trigger: "blur" }
        ],
        type: [{ required: true, message: "请同意条款", trigger: "blur" }],
        company: [
          { required: true, message: "请输入公司名称", trigger: "blur" },
          { min: 2, message: "公司名称最少两个字符", trigger: "blur" }
        ],
        mail: [
          { required: true, message: "请输入邮箱", trigger: "blur" },
          {
            pattern: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
            message: "请检查邮箱格式",
            trigger: "blur"
          }
        ]
      }
    };
  },
  metaInfo() {
    return {
      title: "Movibot官网_工业机器人上下游供应链",
      meta: [
        {
          name: "keywords",
          content:
            "工业机器人_工业机器人上下游供应链_工业机器人品牌_工业自动化设备_行业解决方案"
        },
        {
          name: "description",
          content:
            "Movibot汇聚中国工业机器人上下游供应链优质工业机器人品牌,为工业机器人,智能家庭及商业应用,仓储物流,食品行业,医药行业,汽车行业,机械设备制造,电子行业提供工业自动化设备和行业解决方案"
        }
      ]
    };
  },
  methods: {
    filedCheck(prop) {
      let noSave = false;
      this.$refs.form.validateField(prop, valid => {
        if (valid) {
          noSave = true;
        }
      });
      return noSave;
    },

    onSubmit() {
      const validateFieldList = Object.keys(this.rules);
      const noSave = validateFieldList.some(i => this.filedCheck(i));
      if (!noSave) {
        // 调用保存接口
        this.dataFormSubmit();
      }
    },

    dataFormSubmit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.$api.user.savehelp(this.form).then(res => {
            //注册成功， 跳转到登陆页面
            //console.log(res)
            if (res.data.errno == 0) {
              // var options={
              //   message:"提交成功",
              // }
              // Message.success(options)
              this.$FUnitls.showInfo("提交成功", "success");

              var form = {
                name: "",
                surname: "",
                mail: "",
                phone: "",
                company: "",
                content: ""
              };
              form.type = this.form.type;
              this.form = form;
            } else {
              this.$FUnitls.showInfo(res.data.errmsg, "error");
              return false;
            }
          });
        } else {
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    }
  },

  mounted() {
    if (this.$cookies.get("userinfo") != null) {
      this.form.mail = this.$cookies.get("userinfo").mail;
      this.form.name = this.$cookies.get("userinfo").realname;
      this.form.surname = this.$cookies.get("userinfo").surname;
      this.form.phone = this.$cookies.get("userinfo").phone;
      this.form.company = this.$cookies.get("userinfo").compnay;
    }
  }
};
</script>

<style scoped>
.body {
  background-color: #f3f5f7;
  overflow: hidden;
}
.banner img {
  width: 100%;
}
.contentslist {
  display: flex;
  justify-content: space-between;
  margin-top: 70px;
  margin-bottom: 90px;
}
.contentsus {
  overflow: hidden;
  margin-bottom: 40px;
  background-color: #fff;
}
.contentsus .contentsus-left {
  width: 520px;
  height: 450px;
  float: left;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-left: 40px;
  border-right: 1px solid #e5e5e5;
}
.contentsus .contentsus-right {
  width: 505px;
  height: 450px;
  float: right;
  overflow: hidden;
  padding-right: 40px;
}
.contentsus .contentsus-right img {
  width: 100%;
  height: 100%;
}
.contents-li {
  background-color: #fff;
  border-radius: 3px;
  overflow: hidden;
  width: 343px;
}
.contents-help-li {
  border-radius: 3px;
  overflow: hidden;
  width: 343px;
  text-align: center;
}
.contents-help-li .contents-li-title {
  text-indent: 0;
}
.contents-li img {
  width: 100%;
}
.contents-li-title {
  font-size: 18px;
  color: #333333;
  text-indent: 24px;
  margin-top: 18px;
  margin-bottom: 15px;
  font-weight: 700;
}
.contents-li-desc {
  font-size: 14px;
  color: #000;
  padding: 0 24px;
  margin-bottom: 30px;
  line-height: 2;
}
.contentsus-left-title {
  font-size: 35px;
  color: #333333;
  margin-bottom: 20px;
}
.contentsus-left-info {
  font-size: 24px;
  color: #666666;
  line-height: 1.8;
}
.contentsus-left-lable {
  margin-top: 40px;
  font-size: 18px;
  color: #999999;
}
.contents-title {
  font-size: 30px;
  color: #333333;
  text-align: center;
  letter-spacing: 3px;
  margin-top: 60px;
}
.cloud {
  background: url("/static/help/bg.png") no-repeat;
  background-size: 100% 100%;
  width: 100%;
}
.cloud-title {
  font-size: 30px;
  color: #333333;
  letter-spacing: 3px;
  margin-top: 40px;
  margin-bottom: 15px;
}
.cloud-ul {
  font-size: 20px;
  color: #666666;
  line-height: 1.8;
  margin-bottom: 40px;
}
.cloud-ul-dian {
  margin-right: 20px;
  margin-left: 5px;
  color: #2655ae;
}
.contents-cloud {
  overflow: hidden;
}
.contents-title-save {
  margin-bottom: 40px;
}
.xing {
  display: flex;
  justify-content: space-between;
}
.xing .el-form-item {
  width: 49%;
}

.contentsus-right-title {
  font-size: 20px;
  color: #333;
  text-align: center;
  margin-bottom: 20px;
  margin-top: 20px;
}
.body >>> .el-button--primary {
  float: right;
  background-color: #2655ae;
  border-color: #2655ae;
}
.body >>> .el-button {
  padding: 7px 20px;
}
.body >>> .el-checkbox__label {
  word-break: normal;
  width: auto;
  display: block;
  white-space: pre-wrap;
  word-wrap: break-word;
  overflow: hidden;
  color: #999999;
}
.body >>> .el-checkbox {
  display: flex;
}
.body >>> .el-checkbox__input {
  padding-top: 3px;
}
.body >>> .el-checkbox__label a {
  color: #333;
  text-decoration: underline;
}
.body >>> .el-checkbox__input.is-checked + .el-checkbox__label {
  color: #999999;
}
</style>
<style></style>



// WEBPACK FOOTER //
// src/views/help/cooperation.vue